export default __webpack_public_path__ + "static/media/gharib.2d01413a.jpg";